import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "app/store";
import { emptyResource, failLoading, finishLoading, Resource, startLoading } from "shared/state/resource";
import { GetApprovalSettingsResponse } from "./approvalSettingsDtos";
import { GetApprovalSettings } from "./approvalSettingsThunks";

/**
 * What the approval settings page keeps: the server's answer, once. The edited copy is the page's
 * own state, and the save's result is a toast. Not persisted (NOT_PERSISTED in app/persistConfig.ts).
 */
export interface ApprovalSettingsState {
    settings: Resource<GetApprovalSettingsResponse>;
}

export const initialApprovalSettingsState: ApprovalSettingsState = {
    settings: emptyResource(),
};

const approvalSettingsSlice = createSlice({
    name: "approvalSettingsSlice",
    initialState: initialApprovalSettingsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetApprovalSettings.pending, (state, action) => startLoading(state.settings, action.meta.requestId))
            .addCase(GetApprovalSettings.fulfilled, (state, action) => finishLoading(state.settings, action.meta.requestId, action.payload))
            .addCase(GetApprovalSettings.rejected, (state, action) => failLoading(state.settings, action.meta.requestId));
    },
});

export const selectApprovalSettings = (state: RootState) => state.approvalSettingsSlice.settings;

export default approvalSettingsSlice.reducer;
